import React from 'react';

export default function AssembliesTable() {
	return (
		<div className="table-view table-responsive">
			<table id="assemblies-table" className="table">
				<thead>
					<tr>
						<th>Component Product</th>
						<th>Image</th>
						<th>Quantity</th>
						<th>Wastage </th>
						<th>Unit</th>
						<th>Avaiable</th>
						<th>Stock On hand</th>
						<th>Unit Cost</th>
						<th>Total Cost</th>
						<th>Serial</th>
						<th>Batch</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody></tbody>
			</table>
		</div>
	);
}
